<fgb-mobile-page-header [pageTitle]="'mobile.page.polls.header.title'" backButtonLink="/games" />
<div class="games-banner">
  <div class="container">
    <div class="games-banner-frame">
      <a class="games-banner-buttons d-lg-flex d-none" [routerLink]="['/games']">
        <i class="material-icons text-white">chevron_left</i>
        <span>{{ 'games.banner.back.title' | translate }}</span>
      </a>
      <div class="banner-img-container">
        <img
          [src]="'banners/poll-banner.jpg' | contentAssetImage"
          alt="Games Banners"
          width="962"
          height="210"
          class="games-banner-banners"
        />
      </div>
    </div>
  </div>
</div>

<div class="container mobile-container mt-lg-0 mt-3">
  <div class="pt-3">
    <ng-container *ngIf="pollsQuestion$ | async as pollsQuestions; else shimmerEffect">
      <ng-container *ngIf="pollsQuestions.length > 0">
        <fgbcl-game-polls-question-list [pollsQuestions]="pollsQuestions"> </fgbcl-game-polls-question-list>
      </ng-container>
    </ng-container>
  </div>

  <!-- Shimmer Effect -->
  <ng-template #shimmerEffect>
    <div class="card" aria-hidden="true" *ngFor="let i of [1, 2, 3]">
      <h6 class="card-title placeholder-glow text-center">
        <span class="question-shimmer-effect placeholder col-6"></span>
      </h6>
      <div class="answer-shimmer-effect-section">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
      </div>
      <div class="answer-shimmer-effect-section mt-3">
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
        <p class="card-text placeholder-glow w-100 mb-0 text-center">
          <span class="answer-shimmer-effect placeholder col-12"></span>
        </p>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <p class="card-text placeholder-glow w-40 text-center">
          <span class="presentby-shimmer-effect placeholder col-7"></span>
        </p>
      </div>
    </div>
  </ng-template>
</div>
